// Metadata for the Evolution API rich-message kebab menu in the composer's top panel.
// `type` matches the value routed through EvolutionInteractive/Modal.vue and, for
// button/list/poll/carousel/link, the backend Message#content_type.
export const EVOLUTION_INTERACTIVE_MENU_ITEMS = [
  {
    type: 'button',
    icon: 'i-ph-cursor-click',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.BUTTON',
  },
  {
    type: 'list',
    icon: 'i-ph-list-bullets',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.LIST',
  },
  {
    type: 'location',
    icon: 'i-ph-map-pin',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.LOCATION',
  },
  {
    type: 'poll',
    icon: 'i-ph-chart-bar',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.POLL',
  },
  {
    type: 'sticker',
    icon: 'i-ph-sticker',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.STICKER',
  },
  {
    type: 'carousel',
    icon: 'i-ph-cards',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.CAROUSEL',
  },
  {
    type: 'link',
    icon: 'i-ph-link',
    labelKey: 'CONVERSATION.EVOLUTION_INTERACTIVE.TYPES.LINK',
  },
];
